type WindowLocation = Pick<
  Location,
  'reload' | 'assign' | 'pathname' | 'href' | 'origin' | 'search' | 'replace'
>

export const windowLocation: WindowLocation = {
  reload: () => window.location.reload(),
  assign: (url) => window.location.assign(url),
  replace: (url) => window.location.replace(url),
  get pathname() {
    return window.location.pathname
  },
  get search() {
    return window.location.search
  },
  get href() {
    return window.location.href
  },
  set href(href) {
    window.location.href = href
  },
  get origin() {
    return window.location.origin
  },
}
